module.exports = __webpack_public_path__ + "static/media/Input Manufacturer - GBR care Infographic 04-03-2024 1 1.f7e0f53c.gif";